import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useJobs } from "../jobContext";
import NewJob from "../newJob";
import Modal from "react-modal";
import HamburgerMenu from "./HamburgerMenu";
import "./index.css";
import { apiFetch } from "../../config/api";

const Navbar = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [canManagePayments, setCanManagePayments] = useState(false);
  const { refreshTables } = useJobs();

  useEffect(() => {
    setIsAuthenticated(!!localStorage.getItem("access_token"));
    if (localStorage.getItem("access_token")) apiFetch("/api/payment-processing/settings/").then(()=>setCanManagePayments(true)).catch(()=>setCanManagePayments(false));
  }, []);

  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsAuthenticated(false);
    window.location.href = "/login";
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    isAuthenticated && (
      <div className="navbar-wrapper">
        <div className="navbar-shell">
          <div className="navbar-branding">
            <span className="navbar-eyebrow">Jobsoft</span>
            <span className="navbar-title">Operations Console</span>
          </div>
        <HamburgerMenu
          isAuthenticated={isAuthenticated}
          openModal={openModal}
          logout={logout}
          canManagePayments={canManagePayments}
        />
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Add New Job"
          overlayClassName="new-job-modal-overlay"
          className="new-job-modal-content"
        >
          <NewJob refreshTables={refreshTables} closeModal={closeModal} />
        </Modal>
        <nav className="menu-desktop">
          <NavLink to="/" exact="true" className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>
            Home
          </NavLink>
          <NavLink to="/inventory" className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Inventory</NavLink>
          <NavLink to="/dispatch" className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Dispatch</NavLink>
          <NavLink to="/license" className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Licenses</NavLink>
          <span onClick={openModal} className="nav-item navLink nav-item-cta">
            New Job
          </span>
          <NavLink to="/customers" className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Customer Types</NavLink>
          <NavLink to="/staff" className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Staff Hours</NavLink>
          <NavLink to="/portal" className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Customer Portal</NavLink>
          {canManagePayments && <NavLink to="/payment-settings" className={({ isActive }) => isActive ? "nav-item nav-item-active" : "nav-item"}>Credit Card Processing</NavLink>}
          <span onClick={logout} className="nav-item navLink nav-item-logout">
            Logout
          </span>
        </nav>
        </div>
      </div>
    )
  );
};

export default Navbar;
